import React, { useContext, useState } from "react";
import { Combobox } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { ReactComponent as UAECurrency } from "../../../images/uaecurrency.svg";
import { ReactComponent as UAECurrencyWhite } from "../../../images/uaeCurrencyWhite.svg";
import { CallCenterAPI } from "../../../utils/callcenterAPI";
import { UserContext } from "../../../context/user.context";

import { ReactComponent as zLogo } from "../../../images/zulal-logo/zulal-logo-lg.png"; // Import your logo SVG

// Example TopUp values
const TopUpValues = [
  { name: "Top Value of 50", value: 50, valueArabic: "٥٠" },
  { name: "Top Value of 100", value: 100, valueArabic: "١٠٠" },
  { name: "Top Value of 200", value: 200, valueArabic: "٢٠٠" },
  { name: "Top Value of 300", value: 300, valueArabic: "٣٠٠" },
];

export default function ZulalTopupCard({
  logo,
  onChange,
  availableBalance = 0.0,
}) {
  const [selectedValue, setSelectedValue] = useState(null);
  const [query, setQuery] = useState("");

  // Filter options based on query
  const filteredValues =
    query === ""
      ? TopUpValues
      : TopUpValues.filter(
          (option) =>
            option.value.toString().includes(query) ||
            option.valueArabic.includes(query) ||
            option.name.toLowerCase().includes(query.toLowerCase())
        );

  const handleChange = (val) => {
    setSelectedValue(val);
    if (onChange) {
      onChange(val); // Pass the full object to parent
    }
  };

  return (
    <div>
      <div className="bg-secondaryHover rounded-lg">
        <div className="relative w-full max-w-md mx-auto rounded-2xl overflow-hidden bg-hero-patternmd shadow-lg min-h-[200px]">
          {/* Background Logo (SVG or PNG) */}
          {/* Example SVG: replace with your actual logo */}

          {/* <img className="w-28 sm:w-36" src={logo} alt="" /> */}
          {/* If you have an image instead: */}
          <img
            src={logo}
            alt="logo"
            className="absolute mx-auto justify-center justify-items-center top-1/3 inset-0 w-64 opacity-30 pointer-events-none"
          />

          {/* Foreground Content */}
          <div className="relative flex flex-col justify-between h-full p-8">
            <div>
              <div className="text-textBlack text-4xl font-bold mb-2 mx-auto items-center justify-items-center ">
                <UAECurrency className="w-6 h-6 inline-block mr-2" />
                {Number(availableBalance).toFixed(2)}
              </div>
              <div className="text-cool-gray-600 text-xl font-medium">
                Available balance
              </div>
            </div>
            <div className="flex justify-end mt-32">
              <span className="text-cool-gray-600 px-6 py-2 font-semibold hover:bg-blue-700 transition">
                Zulal Top-Up Card
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-6">
        {/* Responsive Combobox Dropdown */}
        <label htmlFor="topupValue" className="text-cool-gray-700 block mb-2">
          Select Top-Up Value
        </label>
        <Combobox
          value={selectedValue}
          onChange={handleChange}
          name="topupValue"
          id="topupValue"
        >
          <div className="relative">
            <Combobox.Input
              className="w-full rounded-md text-black px-3 py-2 mb-4 focus:outline-none border border-gray-300 focus:ring-2 focus:ring-indigo-500"
              displayValue={(option) =>
                option ? `AED ${option.value} (${option.valueArabic})` : ""
              }
              onChange={(event) => setQuery(event.target.value)}
              placeholder="Type or select amount..."
            />
            <Combobox.Button className="absolute inset-y-0 right-0 flex items-center pr-2">
              <ChevronDownIcon
                className="h-5 w-5 text-gray-400"
                aria-hidden="true"
              />
            </Combobox.Button>
            <Combobox.Options
              className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-textWhite 
                                         py-1 shadow-lg ring-1 ring-black/5 focus:outline-none"
            >
              {filteredValues.length === 0 && query !== "" ? (
                <Combobox.Option
                  value={null}
                  disabled
                  className="cursor-not-allowed select-none px-3 py-2 text-gray-500"
                >
                  No matching values.
                </Combobox.Option>
              ) : (
                filteredValues.map((option) => (
                  <Combobox.Option
                    key={option.value}
                    value={option}
                    className={({ active }) =>
                      `cursor-pointer select-none px-3 py-2 ${
                        active ? "bg-indigo-600 text-white" : "text-gray-900"
                      }`
                    }
                  >
                    {`AED ${option.value} (${option.valueArabic})`}
                  </Combobox.Option>
                ))
              )}
            </Combobox.Options>
          </div>
        </Combobox>
      </div>
    </div>
  );
}
